/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ track: NonNullable<unknown> }} Split_Multiview_Track_LabelInputs */

const en_split_multiview_track_label = /** @type {(inputs: Split_Multiview_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Track ${i?.track}`)
};

const fr_split_multiview_track_label = /** @type {(inputs: Split_Multiview_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Piste ${i?.track}`)
};

const de_split_multiview_track_label = /** @type {(inputs: Split_Multiview_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Track ${i?.track}`)
};

const it_split_multiview_track_label = /** @type {(inputs: Split_Multiview_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Traccia ${i?.track}`)
};

const ru_split_multiview_track_label = /** @type {(inputs: Split_Multiview_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Трек ${i?.track}`)
};

const es_split_multiview_track_label = /** @type {(inputs: Split_Multiview_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pista ${i?.track}`)
};

const zh_cn2_split_multiview_track_label = /** @type {(inputs: Split_Multiview_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`追踪${i?.track}`)
};

const ja_split_multiview_track_label = /** @type {(inputs: Split_Multiview_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`トラック ${i?.track}`)
};

const hi_split_multiview_track_label = /** @type {(inputs: Split_Multiview_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ट्रैक ${i?.track}`)
};

const pt_pt2_split_multiview_track_label = /** @type {(inputs: Split_Multiview_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Faixa ${i?.track}`)
};

/**
* | output |
* | --- |
* | "Track {track}" |
*
* @param {Split_Multiview_Track_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const split_multiview_track_label = /** @type {((inputs: Split_Multiview_Track_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Split_Multiview_Track_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_split_multiview_track_label(inputs)
	if (locale === "de") return de_split_multiview_track_label(inputs)
	if (locale === "it") return it_split_multiview_track_label(inputs)
	if (locale === "ru") return ru_split_multiview_track_label(inputs)
	if (locale === "es") return es_split_multiview_track_label(inputs)
	if (locale === "zh-CN") return zh_cn2_split_multiview_track_label(inputs)
	if (locale === "ja") return ja_split_multiview_track_label(inputs)
	if (locale === "hi") return hi_split_multiview_track_label(inputs)
	if (locale === "pt-PT") return pt_pt2_split_multiview_track_label(inputs)
	return en_split_multiview_track_label(inputs)
});